
    export const User = [
  {
    "id": "22",

  "Name": "Dr Milind Bhalerao",
  " Email Id": " ",
        "LinkedIn": "https://www.linkedin.com/in/milind-bhalerao-a7712b1a/",
  "Recent Photograph": "",
        "image": "https://ik.imagekit.io/wqweoudym/team_2023/173050907_641639890186356_3607702501497993659_n_EOaEfkqUl.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668974054210",
  "Position": "Faculty Co-ordinator"


      },

 
         
         {
        "id":"22",
       
           "Name": "Aashutosh Sunil Karale",
        " Email Id": " ",
           "LinkedIn": "https://www.linkedin.com/in/aashutosh-karale-898326208/",
        "Recent Photograph": "",
           "image":"https://ik.imagekit.io/wqweoudym/team_2023/20221119_230359_-_AASHUTOSH_SUNIL_KARALE_rvFshdjbG.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973210972",
                "Position":"Co-ordinator"

      }, 
              {
        "id":"22",
       
                "Name": "Aryan Bhadoriya",
        " Email Id": " ",
                "LinkedIn": "https://www.linkedin.com/in/bhadoriya-aryan-singh-16b765217",
        "Recent Photograph": "",
                "image":"https://ik.imagekit.io/wqweoudym/team_2023/aryan__9lw6PCjT?ik-sdk-version=javascript-1.4.3&updatedAt=1668974403445",
                "Position":"Vice-ordinator"

      },

      {
        "id": "22",

        "Name": "Gaurav Dattatray Tale ",
        " Email Id": " ",
        "LinkedIn": "https://www.linkedin.com/in/gaurav-tale-32529a205",
        "Recent Photograph": "",
        "image": "https://ik.imagekit.io/wqweoudym/team_2023/20221105_082824_001_-_Gaurav_Tale_KHgGGuJTa.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973730507",
        "Position": "Robocon Co-ordinator"


      },


      {
        "id": "22",

        "Name": "Gauri Pramod Katti",
        " Email Id": " ",
        "LinkedIn": "https://www.linkedin.com/in/gauri-katti-099370210/",
        "Recent Photograph": "",
        "image": "https://ik.imagekit.io/wqweoudym/team_2023/SAVE_20220612_245619_-_GAURI_PRAMOD_KATTI_ZkxfWHSk_.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973701218",
        "Position": "Robocon-Vice Co-ordinator"


      },    
        {
        "id": "22",

        "Name": "Adwait Bokade",
        " Email Id": " ",
          "LinkedIn": "https://www.linkedin.com/in/adwait-bokade-b8371a165/",
        "Recent Photograph": "",
          "image": "https://ik.imagekit.io/wqweoudym/team_2023/Adwait_Np-JiidWg?ik-sdk-version=javascript-1.4.3&updatedAt=1668975044385",
        "Position": "Core-Member"


      },   
         {
        "id": "22",

        "Name": "Shailesh Deshmukh",
        " Email Id": " ",
           "LinkedIn": "https://www.linkedin.com/in/shailesh-deshmukh-183481207",
        "Recent Photograph": "",
           "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG_20220527_141346_404_-_S.D_ihlrB9Ewm.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973294538",
        "Position": "Core-Member"


      },         {
        "id": "22",

           "Name": "Nimita Vishwanath Wagh",
        " Email Id": " ",
           "LinkedIn": "https://www.linkedin.com/in/nimitawagh",
        "Recent Photograph": "",
           "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG_20221119_122250_-_NIMITA_VISHWANATH_WAGH_sgO2K8HrQ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973581463",
        "Position": "Core-Member"


      },     
          {
        "id": "22",

            "Name": "Yash Kondewar ",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/kondewaryash/",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG20220914195740_-_Yash_Kondewar_M9KTCBW6N.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973538769",
        "Position": "Core-Member"


      },     
          {
        "id": "22",

            "Name": "Atharva Jagdale ",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/atharva-jagdale-b20694221",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG_20220705_235239_-_ATHARVA_SUHAS_JAGDALE_GCitZRG7Q.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973488441",
        "Position": "Core-Member"


      },         {
        "id": "22",

            "Name": "Devid Patle ",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/devid-patle-7b0637217",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG20221005113446_2_-_Devid_Patle_HPeZuXY1Z.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973337182",
        "Position": "Core-Member"


      },         {
        "id": "22",

            "Name": "Sagar More ",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/sagar-more-9a3864210/",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/IMG_20220330_183826_VGOUKAS4D.jpg?updatedAt=1678802042509",
        "Position": "Core-Member"


      },         {
        "id": "22",

        "Name": "Samiksha Sheshrao Indalkar",
        " Email Id": " ",
        "LinkedIn": "https://www.linkedin.com/in/samiksha-indalkar-617013234/",
        "Recent Photograph": "",
        "image": "https://ik.imagekit.io/wqweoudym/team_2023/myimage_-_SAMIKSHA_SHESHRAO_INDALKAR_QpZTUu-IzM.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1668970692003",
        "Position": "Core-Member"


      },  {
        "id": "22",

            "Name": "Krushna Shivajirao Maknikar",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/krushna-maknikar",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/Screenshot_20220124-221017_-_Krushna_M__OxeiiPFO.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973625258",
        "Position": "Core-Member"


      },  {
        "id": "22",

            "Name": "Tejas Dabhankar ",
        " Email Id": " ",
            "LinkedIn": "https://www.linkedin.com/in/tejas-dabhankar-3772ba214",
        "Recent Photograph": "",
            "image": "https://ik.imagekit.io/wqweoudym/team_2023/Screenshot_2022-11-19-01-57-33-94_1c337646f29875672b5a61192b9010f9_-_Tejas_Dabhankar_upHuwsCwc.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1668973438066",
        "Position": "Core-Member"


      },

      {
        "id": "19",
        "Email Address": "",
        "Name": "Nipun Dhandage",
        " Email Id": "2019bec098@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/nipun-dhandage-335ab91a7/",
        "Recent Photograph": "https://drive.google.com/open?id=1aciieKuqY70fKaRuZTDjy1_CtakBGOoU",
        "image": "https://ik.imagekit.io/wqweoudym/nipun_0RkXdrBoE.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651168420910",
        "Position": "Co-ordinator 2022"
      },
      {
        "id": "1",
        "Email Address": "SAKSHI NITIN KULKARNI",
        "Name": "Sakshi Nitin Kulkarni",
        " Email Id": "2019bec098@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/kulkarnisakshi/",
        "Recent Photograph": "https://drive.google.com/open?id=1aciieKuqY70fKaRuZTDjy1_CtakBGOoU",
        "image": "https://ik.imagekit.io/wqweoudym/WhatsApp_Image_2022-02-17_at_14.11.53_-_SAKSHI_NITIN_KULKARNI_f8NwnTebH.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1651164443134",
        "Position": "Vice-Co-ordinator 2022"

      }, {
        "id": "2",
        "Email Address": "",
        "Name": "Vedang Fate ",
        " Email Id": "2019bit048@sggs.ac.in  ",
        "LinkedIn": "https://www.linkedin.com/in/vedang-fate-905422101 ",
        "Recent Photograph": "https://drive.google.com/open?id=1Y-4NmDzt_cVKya117iijd08KnMdWmz9k",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20220323_104938_907_-_Vedang_Umakant_Fate_q66znBk8OT.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651169531560",
        "Position": "Core-Member"


      },
      {
        "id": "3",
        "Email Address": "SAURABH AWDHUT SAMBHE",
        "Name": "Saurabh Sambhe",
        " Email Id": "saurabhsambhe02@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/saurabh-sambhe-4a0905143/",
        "Recent Photograph": "https://drive.google.com/open?id=1MNXS2itvHhDFnBMmhTzmwUNq3kTP5qi2",
        "image": "https://ik.imagekit.io/wqweoudym/sauhrab_9NOX-ZS7h.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165452903",
        "Position": "Core-Member"

      },
      {
        "id": "4",
        "Email Address": "VRUSHABH  BHAGWATKAR",
        "Name": "Vrushabh  Bhagwatkar ",
        " Email Id": "2019bcs074@sggs.ac.in ",
        "LinkedIn": "https://www.linkedin.com/in/vrushabh-bhagwatkar-656278194",
        "Recent Photograph": "https://drive.google.com/open?id=1u_nBL65nGZvh_rtPHoh0T1PRy1B5k5gO",
        "image": "https://ik.imagekit.io/wqweoudym/20210219_021346_-_VRUSHABH_SHASHIKANT_BHAGWATKAR_UNs56DsK9.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165580537",
        "Position": "Core-Member"


      },
      {
        "id": "5",
        "Email Address": "VIREN RAHUL BHOSALE",
        "Name": "Viren Rahul Bhosale",
        " Email Id": "2019bit056@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/viren-rahul-bhosale-559015194/",
        "Recent Photograph": "https://drive.google.com/open?id=10mWH67nKaFSaS2P7uOA26K3bquVo6SQk",
        "image": "https://ik.imagekit.io/wqweoudym/photo_-_VIREN_RAHUL_BHOSALE_9A5CIJfrz.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165663194",
        "Position": "Core-Member"


      },
      {
        "id": "6",
        "Email Address": "",
        "Name": "Pratik Singh Thakur",
        " Email Id": "pratikthakur2019@gmail.com ",
        "LinkedIn": "https://www.linkedin.com/in/pratik-singh-thakur-59b582192/",
        "Recent Photograph": "https://drive.google.com/open?id=1Y-4NmDzt_cVKya117iijd08KnMdWmz9k",
        "image": "https://ik.imagekit.io/wqweoudym/pratik_68ha_Nb9b.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651170403751",
        "Position": "Core-Member"


      },

      {
        "id": "7",
        "Email Address": "Amit Sunil Choudhary",
        "Name": "Amit Choudhary",
        " Email Id": "amitchoudhary9425@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/amit-choudhary-756aba1a7",
        "Recent Photograph": "https://drive.google.com/open?id=1mEMC01V-nkFsEqheK70IcPyKrVGKxIHP",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20180110_123351_-_Amit_Sunil_Choudhary__bGnMDT0D.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165224597",
        "Position": "Core-Member"


      },

      {
        "id": "7",
        "Email Address": "Pragati Hanumant Darekar",
        "Name": "Pragati Hanumant Darekar",
        " Email Id": "amitchoudhary9425@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/pragati-darekar-29bb041a7",
        "Recent Photograph": "https://drive.google.com/open?id=1mEMC01V-nkFsEqheK70IcPyKrVGKxIHP",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20220730_142812_o6qawaEACB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1666031039258",
        "Position": "Core-Member"

      },
      {
        "id": "7",
        "Email Address": "Amit Sunil Choudhary",
        "Name": "Atharva Patki",
        " Email Id": "amitchoudhary9425@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/atharva-mahendra-patki-683b3b20a/",
        "Recent Photograph": "https://drive.google.com/open?id=1mEMC01V-nkFsEqheK70IcPyKrVGKxIHP",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20220626_171006_7j2YXhhdQ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1666031732113",
        "Position": "Core-Member"

      },
      {
        "id": "9",
        "Email Address": "ABHISHEK  KORDE",
        "Name": "ABHISHEK  KORDE",
        " Email Id": "abhishekkorde31@gmail.com",
        "LinkedIn": " https://www.linkedin.com/in/abhishek-korde-a173aa206",
        "Recent Photograph": "https://drive.google.com/open?id=1DIUFo8D8nkslCYizxRbG1VnQMD7Vd7rG",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20211221_084145_932_-_ABHISHEK_GANPATRAO_KORDE_p4FLzxync.webp?ik-sdk-version=javascript-1.4.3&updatedAt=1651165143493s",
        "Position": "Core-Member"


      },
      {
        "id": "10",
        "Email Address": "SNEHDEEP PRAKASH ALANE",
        "Name": "Snehdeep Prakash Alane",
        " Email Id": "2019bme015@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/snehdeep-alane-b9013a196/",
        "Recent Photograph": "https://drive.google.com/open?id=11jjj5O62gG8eveqGgwiYzoX3kar7Jy-P",
        "image": "https://ik.imagekit.io/wqweoudym/Image_-_SNEHDEEP_PRAKASH_ALANE_zf6Q5jsoL.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165018246",
        "Position": "Core-Member"


      },
      {
        "id": "11",
        "Email Address": "ONKAR PRADIP CHATRE",
        "Name": "Onkar Pradip Chatre",
        " Email Id": "chatreonkar@gmail.com ",
        "LinkedIn": "https://www.linkedin.com/in/onkar-chatre-390673222/",
        "Recent Photograph": "https://drive.google.com/open?id=1r3xMUAOreaPrsP0Q76BhK8n7e1avF_-7",
        "image": "https://ik.imagekit.io/wqweoudym/Polish_20220228_183009529_-_ONKAR_PRADIP_CHATRE_1AyFGFmdk.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165310813",
        "Position": "Core-Member"


      },
      {
        "id": "12",
        "Email Address": "JAGDISH BHAGWAN PATIL",
        "Name": "Jagdish Bhagwan Patil",
        " Email Id": "jbpatil2111@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/jagdish-patil2111/",
        "Recent Photograph": "https://drive.google.com/open?id=1WjwLH5wgE9_wBNd0TNlUhenj5E8WMELn",
        "image": "https://ik.imagekit.io/wqweoudym/Jagdish_LfJvs6Lbx.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651164723271",
        "Position": "Core-Member"


      },
      {
        "id": "13",
        "Email Address": "Avaroh Music Club",
        "Name": "Jay Thakare",
        " Email Id": "jay05thakare@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/jay-thakare-1983941b6/",
        "Recent Photograph": "https://drive.google.com/open?id=1N1XSnha5HcrkcbCJHS620I6mA--MXQ9G",
        "image": "https://ik.imagekit.io/wqweoudym/profile_pic_-_Avaroh_Music_Club_3Al-vFusx.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651165529904",
        "Position": "Core-Member"


      },

      {
        "id": "14",
        "Email Address": "ISHWAR GORAKH GADE",
        "Name": "Ishwar Gorakh Gade",
        " Email Id": "2020bme504@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/ishwar-gade-7495b6218",
        "Recent Photograph": "https://drive.google.com/open?id=1L_MASREVmNL6iyqWT_OkkmnhdS67S7m9",
        "image": "https://ik.imagekit.io/wqweoudym/IMG20220225101436_-_ISHWAR_GORAKH_GADE_LMPWNgrSu.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651164797513",
        "Position": "Core-Member"


      },
      {
        "id": "15",
        "Email Address": "HANMANT DATTATRAYA KONALE",
        "Name": "Hanmant  Konale ",
        " Email Id": "2019bme003@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/hanmant-konale-72129420b",
        "Recent Photograph": "https://drive.google.com/open?id=1yFRmFV-PLSHgtgMGm920K4AJT8I5FPLz",
        "image": "https://ik.imagekit.io/wqweoudym/20220516_161052_lq9XaCOr5_0tZqv4FPM.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1654569771223",
        "Position": "Core-Member"


      },
      {
        "id": "16",
        "Email Address": "RAMANSHU SANJAY GAWANDE",
        "Name": "Ramanshu Gawande",
        " Email Id": "2019bec057@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/ramanshu-gawande-74b452191",
        "Recent Photograph": "https://drive.google.com/open?id=1O03CnZPAVUMn1tmDYQ-7TYh4noOBXbrY",
        "image": "https://ik.imagekit.io/wqweoudym/Remini20220309232708187_-_RAMANSHU_SANJAY_GAWANDE_F_Sey8kP5.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165774403",
        "Position": "Core-Member"


      },
      {
        "id": "17",
        "Email Address": "JANHAVI VILAS MHATRE",
        "Name": "Janhavi Vilas Mhatre",
        " Email Id": "janhavivmhatre@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/janhavi-mhatre-34b661204",
        "Recent Photograph": "https://drive.google.com/open?id=1HVq-R41M2baEg7B9trpmKxkXjPtLC3y_",
        "image": "https://ik.imagekit.io/wqweoudym/DSC_2318_-_JANHAVI_VILAS_MHATRE_H8EuhCUzr.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165834890",
        "Position": "Core-Member"


      },
      {
        "id": "18",
        "Email Address": "SUYOG PRAVIN MOON",
        "Name": "Suyog Pravin Moon ",
        " Email Id": "2019bme038@sggs.ac.in",
        "LinkedIn": "https://www.linkedin.com/in/suyog-moon-621329214",
        "Recent Photograph": "https://drive.google.com/open?id=1Y-4NmDzt_cVKya117iijd08KnMdWmz9k",
        "image": "https://ik.imagekit.io/wqweoudym/Screenshot_2022-03-10-17-43-43-85_-_SUYOG_PRAVIN_MOON_7cu8rr-8g.png?ik-sdk-version=javascript-1.4.3&updatedAt=1651165903646",
        "Position": "Core-Member"


      }, {
        "id": "20",
        "Email Address": "CHETAN RAMESH PATIL",
        "Name": "Chetan Ramesh Patil",
        " Email Id": "crp20802@gmail.com",
        "LinkedIn": "https://www.linkedin.com/in/chetan-patil-662b021a7/",
        "Recent Photograph": "https://drive.google.com/open?id=1FLngsXNXw-rr0ME-XzC8I6EnVD7ErKpi",
        "image": "https://ik.imagekit.io/wqweoudym/c2_-_CHETAN_RAMESH_PATIL_QRJ4A2n0I.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1651164573737",
        "Position": "Core-Member"


      }, {
        "id": "21",
        "Email Address": "SANDIP BANKATRAO SOLUNKE",
        "Name": "Sandip Solunke",
        " Email Id": "solunkesandip39@gmail.com ",
        "LinkedIn": "https://www.linkedin.com/in/sandip-solunke-5bab45221",
        "Recent Photograph": "https://drive.google.com/open?id=1mkAl_vR2Mi_68QhW3tHXQZWvf4zcJoS3",
        "image": "https://ik.imagekit.io/wqweoudym/PicsArt_02-28-12.37.41-02_-_SANDIP_BANKATRAO_SOLUNKE_xKgU3PFQa.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1651165097604",
        "Position": "Core-Member"


      },
      {
        "id": "22",

        "Name": "Yash Kholapure",
        " Email Id": " ",
        "LinkedIn": "https://www.linkedin.com/in/yash-kholapure-144147208/?originalSubdomain=in",
        "Recent Photograph": "https://drive.google.com/open?id=1mkAl_vR2Mi_68QhW3tHXQZWvf4zcJoS3",
        "image": "https://ik.imagekit.io/wqweoudym/IMG_20210121_131437_583_-_YASH_PRAMOD_KHOLAPURE_pbO80kc24.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1651164969714",
        "Position": "Core-Member"


      },    
    ]
  